// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__5UAxe","message":"style_message__t22rb","description":"style_description__2kKjS","loading":"style_loading__HQRgN"};